import apolloClient from '../../utils/apollo-client';
import { employerSignComplete as mutation } from '../graphql/docusign';
import Mock from '@/api/approvals/mock';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function employerSignComplete(payLoad) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.employerSignComplete;
  }

  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: {
        payLoad
      }
    })
  );

  return response.data.employerSignComplete;
}
